import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const makeBarStyles = makeStyles({
  bar: { backgroundColor: (props) => props.backgroundColor },
});

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  variant: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  barBackgroundColor: PropTypes.string.isRequired,
};

export function UnstyledNodeLinearProgress({ classes, variant, value, barBackgroundColor }) {
  const barStyle = makeBarStyles({ backgroundColor: barBackgroundColor }).bar;
  return (
    <LinearProgress
      variant={variant}
      value={value}
      classes={{
        root: classes.linearBarRoot,
        bar: barStyle,
      }}
    />
  );
}

UnstyledNodeLinearProgress.propTypes = propTypes;

const styles = (theme) => ({
  linearBarRoot: {
    backgroundColor: theme.customColors.lightGrey,
  },
});

export default withStyles(styles)(UnstyledNodeLinearProgress);
